import type { MenuContextProps } from "../../../types";
import React, { createContext, useState } from "react";
import {MenuProviderProps} from "../../../types/layout";

export const MenuContext = createContext({} as MenuContextProps);


export const MenuProvider = (props: MenuProviderProps) => {
    const [activeMenu, setActiveMenu] = useState("");

    const value = {
        activeMenu,
        setActiveMenu,
    };

    return (
        <MenuContext.Provider value={value}>
            {props.children}
        </MenuContext.Provider>
    );
};
